import PermissionChecker from '@/SDK/PermissionChecker'
import ClientLogger from '@/SDK/ClientLogger'
import { API_URL, USE_KONG_API } from '@/utils/env'
import { getKONGToken } from '@/utils/auth/tokenFetcher'

export const PCInstance = new PermissionChecker('RBAC', API_URL, USE_KONG_API ? getKONGToken : undefined)
export const CLInstance = new ClientLogger()
